import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'add-button',
  templateUrl: './add-button.component.html',
  styleUrl: './add-button.component.scss',
  imports: [RouterLink]
})
export class AddButtonComponent {

  @Input() label = '' 
  @Input() link = ''
  @Output() onClick = new EventEmitter<any>();

  doClick() {
    this.onClick.emit();
  }
}
